export default __webpack_public_path__ + "static/media/jacksonvilleJaguarsVideo-2x.0817b7c1.jpg";